import { render } from "./CreateAccount.vue?vue&type=template&id=0c1f7658"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=0c1f7658&lang=scss"
script.render = render

export default script